define(function(require, exports, module) {
    'use strict';

    var CashierMethodModel = require('portlets/cashier/cashier.method.model');
    var cashierConfig = require('portlets/cashier/cashier.config');
    var config = require('config');
    var i18n = require('i18n');

    module.exports = CashierMethodModel.extend({
        initialize: function() {
            var data = this.attributes;

            CashierMethodModel.prototype.initialize.apply(this, arguments);
            data.commercialName = this.getCommercialName(data);
            if (data.config.redirect) {
                data.config.redirectType = 'popup';
            }
        },

        /**
         * Attach config from cashier.config
         * @param {Object} data
         * @private
         */
        _attachCashierConfig: function(data) {
            var individualConfig = cashierConfig(data.code + this.configType)
                || cashierConfig(data.methodCode + this.configType);

            data.isGeneric = !individualConfig || individualConfig.isGeneric;
            data.config = individualConfig || cashierConfig('generic' + this.configType);

            if (!data.config.validationConfig) {
                data.config.validationConfig = cashierConfig('basic' + this.configType).validationConfig;
            }

            data.config.redirect = 'redirect' in data.config
                ? data.config.redirect
                : this.get('depositType') === 'redirect' || this.get('withdrawType') === 'redirect';
            data.config.redirectType = data.config.redirectType || this.get('redirectType');
        },

        getCommercialName: function(data) {
            var paymentsNames = config.get('cashier_payments_methods_commercial_names');

            return paymentsNames[data.code] || data.name;
        },

        /**
         * TODO: please remove the next piece of code after IMS change request for 33026 is done
         */
        set: function() {
            CashierMethodModel.prototype.set.apply(this, arguments);
            if (this.changed.code) {
                this.setNameByTranslation();
            }
            return this;
        },

        setNameByTranslation: function() {
            var name = this.get('name');
            if (name) {
                return;
            }
            name = this.defineNameByTranslation();
            this.set('name', name);
        },

        defineNameByTranslation: function() {
            var code = this.get('code');
            var key = this.defineTranslationKey(code);
            return i18n.tExt(key, code);
        },

        defineTranslationKey: function(code) {
            code = code || this.get('code');
            return 'playtech.mobile.system.mobile-cashier.method.' + code + '.title';
        }
    });
});
